import { DEFAULT_LOCALE } from './constants';

export function formatNumber(value: number, options?: Intl.NumberFormatOptions) {
  return value.toLocaleString(DEFAULT_LOCALE, options);
}
